import React from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  AspectRatio,
} from '@chakra-ui/react'

interface IVideoModal {
  isOpen: boolean
  onClose: () => void
  onClick: () => void
}

function PlayVideo({ isOpen, onClose, onClick }: IVideoModal) {
  const modalSize: any = {
    md: '900px',
    base: '800px',
    lg: '1400px',
    sm: '700px',
  }
  return (
    <>
      <Modal
        isOpen={isOpen}
        size={['sm', 'md', 'base', 'lg']}
        onClose={onClose}
        isCentered
      >
        <ModalOverlay />
        <ModalContent maxW={modalSize}>
          <ModalBody padding={0}>
            <AspectRatio maxW="960px" ratio={16 / 9}>
              <iframe
                title="naruto"
                src="https://www.youtube.com/embed/6D3yzgMNjwU"
                allowFullScreen
              />
            </AspectRatio>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}

export default PlayVideo
